<template>
  <div class="preview-carousel">

    <zy-square>
      <swiper
          ref="swiperTop"
          class="swiper"
          :options="swiperOption"
      >
        <swiper-slide v-for="(item, idx) in goods.img_list" :key="'carousel_' + idx">
          <img :src="item" class="img"/>
        </swiper-slide>
      </swiper>
    </zy-square>

<!--    <div class="store">-->
<!--      <div>-->
<!--        <div>天猫超市</div>-->
<!--        <div>商家综合体验 5.0 高</div>-->
<!--      </div>-->

<!--      <div>-->
<!--        <div>宝贝描述 5.0 高</div>-->
<!--        <div>宝贝描述 5.0 高</div>-->
<!--        <div>宝贝描述 5.0 高</div>-->
<!--      </div>-->
<!--    </div>-->

    <swiper
        ref="swiperThumbs"
        class="swiper-preview"
        :options="swiperPreviewOption"
    >
      <swiper-slide v-for="(item, idx) in goods.img_list" :key="'preview_' + idx">
        <zy-square>
          <img :src="item" class="img"/>
        </zy-square>

      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import ZySquare from "@/components/zy-square/index.vue";

export default {
  name: 'carousel-images',
  components: {
    ZySquare,
    Swiper,
    SwiperSlide,
  },
  props: {
    goods: Object
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 10,
        slidesPerView: 1,
        loop: true,
        freeMode: false,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      swiperPreviewOption: {
        spaceBetween: 8,
        slidesPerView: 4,
        loop: true,
        freeMode: false,
        loopedSlides: 0, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  methods: {
    onSlideChange(e) {
      console.log(e);
    },
    onPreviewSlideChange(e) {
      console.log(e);
    },
  },
}
</script>


<style lang="scss" scoped>
.preview-carousel {
  border-radius: 10px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  position: relative;

  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .swiper {
    width: 100%;
    height: 100%;

    .img {
      border-radius: 10px;
    }
  }

  .swiper-preview {
    margin-top: 10px;
    margin-bottom: 10px;

    .img {
      border-radius: 10px;
    }

    .swiper-slide-next {
      opacity: 0.5;
    }

    .swiper-slide-prev {
      opacity: 0.5;
    }

    .swiper-slide-active {
      opacity: 1;
    }
  }
}

.store {
  display: flex;
  background: #FCE6FF;
  border-radius: 6px;
  margin-top: 14px;
  margin-bottom: 14px;
  padding: 4px;
  font-size: 10px;
}
</style>
